module.exports = __webpack_public_path__ + "dc33743257847d8c85d27fe9b7563df0.png";